<template>
  <div class="container-home">
    <div class="concept-left">
      <!-- 技术概念 -->
      <div class="page1" v-loading="loading" v-if="keywordFlag && conceptList.length > 0">
        <h3>技术概念</h3>
        <div class="page1-main">
          <el-tabs v-model="editableTabsValue" @tab-click="handleClickTab" ref="tabs">
            <el-tab-pane v-for="(item, index) in conceptList" :key="index" :label="item.name" :name="item.name" lazy>
              <p class="page1-load" v-if="descLoading">技术概念解析<img class="rotating-image" src="../../assets/images/loading_s.svg" /></p>
              <div v-if="conceptVal && !descLoading" class="content">
                <typewriter :text="conceptVal" :speed="15"></typewriter>
              </div>
            </el-tab-pane>
          </el-tabs>
          <p class="tips" v-if="conceptList.length > 0"><i class="el-icon-info"></i>以上内容为AI生成，不代表开发者立场</p>
        </div>
      </div>
      <!-- 数据概览  v-loading="analyLoading"-->
      <div class="page2" v-if="keywordFlag">
        <h3>数据概览</h3>
        <div class="page2-main">
          <ul>
            <li @click="toList('1')">
              <img src="../../assets/images/s-lunwen.png" alt="" />
              <div class="page2-right">
                <p class="title">论文数量 <i class="el-icon-arrow-right"></i></p>
                <p class="num">{{ lunwenNum }}</p>
              </div>
            </li>
            <li @click="toList('2')">
              <img src="../../assets/images/s-zuozhe.png" alt="" />

              <div class="page2-right">
                <p class="title">作者数量 <i class="el-icon-arrow-right"></i></p>
                <p class="num">{{ zuozheNum }}</p>
              </div>
            </li>
            <li @click="toList('3')">
              <img src="../../assets/images/s-jigou.png" alt="" />
              <div class="page2-right">
                <p class="title">机构数量 <i class="el-icon-arrow-right"></i></p>
                <p class="num">{{ jigouNum }}</p>
              </div>
            </li>
            <li @click="toList('4')">
              <img src="../../assets/images/s-qikan.png" alt="" />

              <div class="page2-right">
                <p class="title">期刊数量 <i class="el-icon-arrow-right"></i></p>
                <p class="num">{{ qikanNum }}</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- 研究趋势 -->
      <div class="page3" v-loading="themeLoading" v-show="keywordFlag">
        <h3>研究趋势</h3>
        <div class="page3-main" v-show="themeData">
          <CategoryEcharts :themeData="themeData" @category-event="handleCategoryData"></CategoryEcharts>
        </div>
        <el-tabs v-model="activeName" v-if="themeData">
          <el-tab-pane label="概念解读" name="first">
            <div class="analysis-class">
              <p class="analysis-load" v-if="analysisLoading">概念解读<img class="rotating-image" src="../../assets/images/loading_s.svg" /></p>
              <typewriter v-if="analysisInfo && !analysisLoading" :text="analysisInfo" :speed="15"></typewriter>
              <p class="analysis-tips"><i class="el-icon-info"></i>以上内容为AI生成，不代表开发者立场</p>
            </div>
          </el-tab-pane>
          <el-tab-pane label="使用说明" name="second">
            <div class="analysis-second">
              <h5>计算逻辑说明</h5>
              <p>以时间序列为基础，逐年统计论文数量、论文作者数量和论文所属机构数量，并形成一定时间范围内的趋势图。</p>
              <h5>图表使用说明</h5>
              <p>
                <span>折线图：</span
                >折线图可以清晰地展示数据随时间或其他变量的变化趋势。通过观察折线的上升或下降趋势，可以快速了解数据的增长、下降或波动情况。多条折线放在同一个图表中，可以直观地比较它们的趋势和关系，帮助观察者更好地理解数据之间的差异和相似性。通过观察折线的走势和模式，可以推测未来的发展方向和可能的
              </p>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div class="noData" v-if="!themeData">
          <el-empty description="暂无数据"></el-empty>
        </div>
      </div>
      <div class="page5">
        <h3>研究热点</h3>
        <div class="page5-tab">
          <div class="page5-tab-item" @click="handleWordTab(1)">
            <img v-if="wordTabIndex != 1" src="../../assets/images/wordcloud.png" alt="" />
            <img v-if="wordTabIndex == 1" src="../../assets/images/wordcloud-checked.png" alt="" />
          </div>
          <!-- <div class="page5-tab-item" @click="handleWordTab(4)">
            <img v-if="wordTabIndex != 4" src="../../assets/images/juzhentu.png" alt="" />
            <img v-if="wordTabIndex == 4" src="../../assets/images/juzhentu-checked.png" alt="" />
          </div> -->
          <div class="page5-tab-item" @click="handleWordTab(2)">
            <img v-if="wordTabIndex != 2" src="../../assets/images/zhuzhuangtu.png" alt="" />
            <img v-if="wordTabIndex == 2" src="../../assets/images/zhuzhuangtu-checked.png" alt="" />
          </div>
          <div class="page5-tab-item" @click="handleWordTab(3)">
            <img v-if="wordTabIndex != 3" src="../../assets/images/table.png" alt="" />
            <img v-if="wordTabIndex == 3" src="../../assets/images/table-checked.png" alt="" />
          </div>
        </div>
        <wordcloud v-if="wordcloudData.length > 0 && wordTabIndex == 1" :wordcloudData="wordcloudData" @wordcloud-event="handlewordCloud"></wordcloud>
        <template v-if="wordTabIndex == 2">
          <zhuzhuangtu v-show="wordcloudData.length > 0" :wordcloudData="wordcloudData" @wordcloud-event="handlewordCloud"></zhuzhuangtu>
        </template>
        <template v-if="wordTabIndex == 3">
          <tableData v-if="wordcloudData.length > 0" :wordcloudData="wordcloudData"></tableData>
        </template>

        <el-tabs v-model="page5Active" v-if="wordcloudData.length > 0">
          <el-tab-pane label="图表解读" name="first">
            <div class="page5_first" :class="{ page5_min90: page5Word }">
              <div class="analysis-class" v-if="page5Word">
                <p class="analysis-load" v-if="!hotwordLoading">图表解读<img class="rotating-image" src="../../assets/images/loading_s.svg" /></p>
                <typewriter v-if="hotWordsInfo && hotwordLoading" :text="hotWordsInfo" :speed="15"></typewriter>
                <p class="analysis-tips"><i class="el-icon-info"></i>以上内容为AI生成，不代表开发者立场</p>
              </div>
              <!-- 遮罩层 -->
              <div class="mask" v-if="!page5Word">
                <div class="mask_airead">
                  <img src="../../assets/images/mask_airead.png" />
                  <span @click="showPage5Word"><img src="../../assets/images/mask_icon.png" alt="" /><small>AI生成图表解读</small></span>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="使用说明" name="second">
            <div class="analysis-second">
              <h5>计算逻辑说明</h5>
              <p>根据从论文中抽取到的技术主题词，逐篇统计出现特定技术主题词的论文数量，并利用可视化图表更直观地展示论文中的技术热点和关键词分布。</p>
              <h5>图表使用说明</h5>
              <p><span>词云图：</span>词云图可以将文本中出现的关键词按照出现频率大小的不同展示不同的字体大小和颜色，直观地呈现文本的关键内容，帮助观察者快速发现文本中的热门话题和关注点。</p>
              <!-- <p><span>矩阵树图：</span>矩阵树图可以将文本中出现的关键词按照出现频率的大小展示不同矩形面积的色块，直观地呈现文本的占比关系和关键内容，帮助观察者快速发现文本中的热门话题和关注点。</p> -->
              <p><span>柱状图：</span>柱状图通过按照数量或频率的大小对不同类别或变量进行排序，并将数据以垂直柱状条的形式表示，可以清晰地展示每个类别或变量的大小顺序和频率差异。观察者可以直观地比较它们之间的差异，理解数据的相对大小和排行，快速识别出数据中的重点和关键信息。</p>
            </div>
          </el-tab-pane>
        </el-tabs>

        <div class="noData" v-if="wordcloudData.length == 0">
          <el-empty description="暂无数据"></el-empty>
        </div>
      </div>
    </div>
    <!-- <div class="subject-card">
      <div style="padding: 25px">
        <h3 class="section-title">
          <i class="el-icon-s-check"></i>
          虚拟学科馆员服务
        </h3>

        <div style="text-align: center; padding: 20px 0">
          <img src="https://randomuser.me/api/portraits/women/65.jpg" alt="学科馆员" style="width: 120px; height: 120px; border-radius: 50%; border: 4px solid var(--light)" />
          <h3 style="font-size: 1.4rem; margin: 15px 0 5px; color: #1a3c5f">畅想学科馆员</h3>
          <p style="color: #2c5f97; margin-bottom: 20px">计算机科学学科专家</p>
          <p style="color: #666; margin-bottom: 25px">提供学科资源导航、文献检索指导、投稿支持等服务</p>

          <div class="section-zixun" style="display: flex; flex-direction: column; gap: 15px">
            <el-button type="primary" class="action-btn primary-action" @click="toKefu">
              <i class="el-icon-chat-round"></i>
              在线咨询
            </el-button>
          </div>
        </div>
        <div class="new-news" v-if="newsLsit.length > 0">
          <h3>
            <i class="el-icon-s-order"></i>
            学科动态
          </h3>
          <ul style="list-style: none">
            <li v-for="(item, index) in newsLsit" :key="index" @click="toNewsDetail(item.sid)">
              <i></i>
              <div>
                <div class="news-title line2" :title="item.title">
                  {{ item.title }}
                </div>
                <div style="font-size: 0.9rem; color: #888">
                  {{ item.infoDate }}
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import CategoryEcharts from "@/components/categoryEcharts.vue";
import typewriter from "@/components/typewriter.vue";
import wordcloud from "@/components/wordcloud.vue";
import zhuzhuangtu from "@/components/zhuzhuangtu.vue";
import tableData from "@/components/WordcloudTable.vue";
import { EventBus } from "../../utils/eventBus";

export default {
  components: {
    CategoryEcharts,
    typewriter,
    wordcloud,
    zhuzhuangtu,
    tableData,
  },
  data() {
    return {
      loading: false,
      tabIndex: 0,
      keywordFlag: true,
      conceptList: [], //技术概念tab
      editableTabsValue: "", //选中的值
      conceptVal: "", //选中的描述
      conceptId: "", //选中的id
      descLoading: false, //点击tab时的 loading
      analyLoading: false, //数据概览loading
      themeLoading: false, //研究趋势loading
      analysisList: [], //数据概览列表
      themeData: null, //趋势
      lunwenNum: 0,
      jigouNum: 0,
      zuozheNum: 0,
      qikanNum: 0,

      analysisInfo: "",
      activeName: "first",
      analysisLoading: false,
      analysisIndex: 0,

      // 研究热点 词云图数
      wordcloudData: [],
      wordTabIndex: 1,

      page5Active: "first",
      page5Word: false,
      hotWordsInfo: "",
      hotwordLoading: false,

      newsLsit: [],
      restoreTimers: [],
    };
  },
  created() {
    EventBus.$on("submitSubject", id => {
      // 标记数据已加载
      this.getSubjectId(id);
    });
  },
  mounted() {
    this.addScrollListener();
    this.keywordFlag = true;
    this.loading = true;
    this.analyLoading = true;
    this.themeLoading = true;
    this.timer = setInterval(() => {
      if (sessionStorage.getItem("subjectNodes")) {
        let id = JSON.parse(sessionStorage.getItem("subjectNodes")).id;
        this.getSubjectId(id);
      }
    }, 300);
  },
  activated() {
    if (sessionStorage.getItem("chongda_skip_restore_once") === this.$route.path) {
      sessionStorage.removeItem("chongda_skip_restore_once");
      sessionStorage.removeItem("chongda_subject_gateway_should_restore");
      this.$nextTick(() => {
        [0, 80, 180, 400, 800, 1200, 1800].forEach(delay => {
          setTimeout(() => {
            this.scrollPageToTop();
            this.resetInnerScrollableElements();
          }, delay);
        });
      });
      return;
    }
    if (sessionStorage.getItem("chongda_subject_gateway_should_restore") === "1") {
      sessionStorage.removeItem("chongda_subject_gateway_should_restore");
      this.$nextTick(() => {
        this.restoreSavedScrollTopRepeatedly();
      });
    }
  },
  deactivated() {
    this.clearRestoreTimers();
  },
  beforeRouteLeave(to, from, next) {
    sessionStorage.setItem("chongda_subject_gateway_scroll_top", String(this.getCurrentScrollTop()));
    sessionStorage.setItem("chongda_subject_gateway_should_restore", "1");
    this.clearRestoreTimers();
    next();
  },

  beforeDestroy() {
    this.clearRestoreTimers();
    this.removeScrollListener();
    EventBus.$off("submitSubject");
  },

  methods: {
    clearRestoreTimers() {
      this.restoreTimers.forEach(timer => clearTimeout(timer));
      this.restoreTimers = [];
    },
    getScrollTargets() {
      const elements = [
        document.getElementById("subapp-container"),
        document.querySelector(".view"),
        document.scrollingElement,
        document.documentElement,
        document.body,
      ].filter(Boolean);
      return elements.filter((element, index) => elements.indexOf(element) === index);
    },
    getCurrentScrollTop() {
      return this.getScrollTargets().reduce((top, element) => Math.max(top, element.scrollTop || 0), window.pageYOffset || 0);
    },
    scrollPageToTop() {
      this.getScrollTargets().forEach(element => {
        element.scrollTop = 0;
      });
      window.scrollTo(0, 0);
    },
    resetInnerScrollableElements() {
      const nodes = this.$el && this.$el.querySelectorAll ? Array.from(this.$el.querySelectorAll("*")) : [];
      nodes.forEach(element => {
        const style = window.getComputedStyle(element);
        const canScroll = element.scrollHeight > element.clientHeight;
        const allowsScroll = style.overflowY === "auto" || style.overflowY === "scroll" || style.overflowY === "overlay";
        if (canScroll || allowsScroll) {
          element.scrollTop = 0;
        }
      });
    },
    setScrollTop(top) {
      this.getScrollTargets().forEach(element => {
        element.scrollTop = top;
      });
      window.scrollTo(0, top);
    },
    restoreSavedScrollTopRepeatedly() {
      const top = Number(sessionStorage.getItem("chongda_subject_gateway_scroll_top") || 0);
      this.clearRestoreTimers();
      [0, 80, 180, 320, 500].forEach(delay => {
        const timer = setTimeout(() => {
          this.setScrollTop(top);
        }, delay);
        this.restoreTimers.push(timer);
      });
    },
    addScrollListener() {
      const targets = [window, document, document.body, document.documentElement];
      targets.forEach(target => {
        if (target && target.addEventListener) {
          target.addEventListener("scroll", this.listenerScroll, { passive: true, capture: true });
        }
      });
    },
    removeScrollListener() {
      const targets = [window, document, document.body, document.documentElement];
      targets.forEach(target => {
        if (target && target.removeEventListener) {
          target.removeEventListener("scroll", this.listenerScroll, { passive: true, capture: true });
        }
      });
    },
    listenerScroll() {
      const scrollTop1 = document.documentElement.scrollTop;
      const scrollTop2 = document.body.scrollTop;
      const scrollTop3 = window.scrollY || window.pageYOffset;
      this.scrollTop = scrollTop1 || scrollTop2 || scrollTop3 || 0;
      if (this.scrollTop > 350) {
        if (this.analysisLoading) {
          setTimeout(() => {
            this.analysisLoading = false;
          }, 500);
        }
      }
    },
    getSubjectId(id) {
      window.clearInterval(this.timer);
      this.subjectId = id;
      this.wordcloudData = [];
      this.themeData = null;
      this.descLoading = true;
      this.hotWordsInfo = "";
      this.page5Word = false;
      this.getConceptList();
    },
    handleClickTab(tab) {
      this.wordcloudData = [];
      this.themeData = null;
      this.descLoading = true;
      this.editableTabsValue = this.conceptList[tab.index].name;
      this.conceptId = this.conceptList[tab.index].conceptId;
      this.hotWordsInfo = "";
      this.page5Word = false;
      this.getAnalysis();
      this.getThemeData();
      this.getWordCloudData();

      setTimeout(() => {
        this.getDescription();
      }, 1200);
    },
    getNewsList() {
      this.$http({
        url: `api/v1/subject/gateway/info/new/list?subjectId=${this.subjectId}`,
        method: "get",
      }).then(res => {
        this.newsLsit = res.data;
      });
    },
    // tab列表
    getConceptList() {
      this.$http({
        url: `api/v1/subject/gateway/concept/list?subjectId=${this.subjectId}`,
        method: "get",
      }).then(res => {
        this.$nextTick(() => {
          this.loading = false;
          this.conceptList = res.data;
          if (this.conceptList.length > 0) {
            setTimeout(() => {
              this.isRightArrow();
            }, 300);
            this.editableTabsValue = this.conceptList[0].name;
            this.conceptId = this.conceptList[0].conceptId;
            this.descLoading = true;
            this.getNewsList();
            this.getAnalysis();
            this.getThemeData();
            this.getWordCloudData();
            setTimeout(() => {
              this.getDescription();
            }, 1200);
          } else {
            this.loading = false;
            this.analyLoading = false;
            this.themeLoading = false;
            this.themeData = null; //趋势
            this.lunwenNum = 0;
            this.jigouNum = 0;
            this.zuozheNum = 0;
            this.qikanNum = 0;
          }
        });
      });
    },
    // 动态显示隐藏左右箭头
    isRightArrow() {
      this.$nextTick(() => {
        // 找出下面对应的nav实例
        function findTabNavVue(vueStance) {
          const childrens = vueStance.$children;
          const len = childrens.length;
          for (let i = 0; i < len; i++) {
            const child = childrens[i];
            if (child.scrollNext) return child;
          }
        }
        const navVue = findTabNavVue(this.$refs.tabs);
        if (navVue.$el.querySelector(".el-tabs__nav-prev")) {
          navVue.$el.querySelector(".el-tabs__nav-prev").style.visibility = "hidden";
        }
        if (navVue.scrollable) {
          let nextNode;
          let nextNode2;
          navVue.$watch("navOffset", function (currentOffset) {
            var navSize = this.$refs.nav["offsetWidth"];
            var containerSize = this.$refs.navScroll["offsetWidth"];
            const isRight = navSize - currentOffset <= containerSize;
            const isLeft = currentOffset == 0;
            nextNode = nextNode ? nextNode : navVue.$el.querySelector(".el-tabs__nav-next");
            nextNode.style.visibility = isRight ? "hidden" : "";

            nextNode2 = nextNode2 ? nextNode2 : navVue.$el.querySelector(".el-tabs__nav-prev");
            nextNode2.style.visibility = isLeft ? "hidden" : "";
          });
        }
      });
    },
    // 获取描述
    getDescription() {
      this.$http({
        url: "api/v1/concept/message?conceptId=" + this.conceptId,
        method: "get",
      }).then(res => {
        this.descLoading = false;
        this.conceptVal = res.data;
      });
    },
    // 数据概览
    getAnalysis() {
      this.$http({
        url: "api/v1/concept/analysis?conceptId=" + this.conceptId,
        method: "get",
      }).then(res => {
        this.analyLoading = false;
        this.analysisList = res.data;
        this.analysisList.forEach(element => {
          if (element.conceptType == 10) {
            this.lunwenNum = element.count;
          }
          if (element.conceptType == 20) {
            this.zuozheNum = element.count;
          }
          if (element.conceptType == 30) {
            this.jigouNum = element.count;
          }
          if (element.conceptType == 40) {
            this.qikanNum = element.count;
          }
        });
      });
    },
    //研究趋势
    getThemeData() {
      this.$http({
        url: "api/v1/concept/area/trend?conceptId=" + this.conceptId,
        method: "get",
      }).then(res => {
        this.themeLoading = false;
        if (res.data.conceptTrendTypeBoList && res.data.conceptTrendTypeBoList.length > 0 && res.data.yearList && res.data.yearList.length > 0) {
          this.themeData = res.data;
        } else {
          this.themeData = null;
        }
        setTimeout(() => {
          this.analysisLoading = false;
          this.getAnalysisInfo();
        }, 500);
      });
    },
    // 概念解读
    getAnalysisInfo() {
      this.$http({
        url: "api/v1/concept/area/trend/analysis?conceptId=" + this.conceptId,
        method: "get",
      }).then(res => {
        this.analysisInfo = res.data;
      });
    },
    toList(val) {
      this.$router.push({
        path: "/subjectGateway/list",
        query: {
          type: val,
          value: this.editableTabsValue,
          conceptId: this.conceptId,
        },
      });
    },
    //研究热点
    getWordCloudData() {
      this.$http({
        url: "api/v1/concept/hot/keyword?conceptId=" + this.conceptId,
        method: "get",
      }).then(res => {
        this.wordcloudData = res.data;
        this.wordcloudData.forEach((element, index) => {
          this.wordcloudData[index].value = element.count;
          this.wordcloudData[index].name = element.word;
        });
      });
    },
    handlewordCloud(val) {
      this.$router.push({
        path: "/subjectGateway/list",
        query: {
          type: 1,
          value: this.editableTabsValue,
          conceptId: this.conceptId,
          words: val.data.name ? val.data.name : val.name,
        },
      });
    },
    handleCategoryData(val) {
      // let _url = this.$router.resolve({
      //   path: "/subjectGateway/list",
      //   query: { type: val.seriesIndex + 1, value: this.editableTabsValue, conceptId: this.conceptId, years: val.name },
      // });
      // window.open(_url.href, "_blank");
    },
    // 热点里的图标切换事件
    handleWordTab(val) {
      this.wordTabIndex = val;
    },
    showPage5Word() {
      this.page5Word = true;
      this.$http({
        url: "api/v1/concept/hot/keyword/analysis?conceptId=" + this.conceptId,
        method: "get",
      }).then(res => {
        this.hotWordsInfo = res.data;
        setTimeout(() => {
          this.hotwordLoading = true;
        }, 1500);
      });
    },
    toNewsDetail(sid) {
      this.$http({
        url: "api/v1/discipline/link?sid=" + sid,
        method: "GET",
      }).then(res => {
        const urlRegex = /^https?:\/\//i;
        if (urlRegex.test(res.data)) {
          window.open(res.data, "_self");
        } else {
          this.$message.error("无法访问");
        }
      });
      //  this.$router.push({ path: "/infoDetail", query: { sid: sid } });
    },
    toKefu() {
      this.$message.warning("功能开发中");
    },
  },
};
</script>

<style lang="scss" scoped>
.container-home {
  width: calc(100% - 40px);
  max-width: 1300px;
  min-width: 0;
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
  box-sizing: border-box;
  .concept-left {
    flex: 1;
    min-width: 0;
    margin-right: 20px;
    .rotating-image {
      animation: rotate 1s linear infinite;
    }
    @keyframes rotate {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }
    .page4 {
      span {
        margin-right: 25px;
        line-height: 30px;
        cursor: pointer;
        display: inline-block;
        &:hover {
          color: #63ace5;
        }
      }
      .checked {
        color: #63ace5;
      }
    }
    .page1,
    .page2,
    .page3,
    .page4,
    .page5 {
      margin-top: 20px;
      padding: 20px;
      background: #fff;
      border-radius: 4px;
      box-shadow: 0 1px 4px 0 rgba(39, 42, 46, 0.1);
      h3 {
        height: 62px;
        margin: -20px -20px 0;
        padding: 0 20px;
        color: #202224;
        font-size: 18px;
        line-height: 62px;
        background: url("../../assets/images/trend_h3.png") no-repeat 0;
        background-size: 240px 100%;
      }
    }

    .page1 {
      .page1-main {
        min-height: 100px;
        .tabs-wrap {
          position: relative;
          display: flex;
          flex: auto;
          overflow: hidden;
          white-space: nowrap;
          transform: translate(0);
        }
      }
      ::v-deep .el-tabs__item {
        color: #636870;
        cursor: pointer;
        position: relative;
        font-size: 16px;
      }
      ::v-deep .is-active {
        color: #63ace5;
        font-size: 20px;
        font-weight: bold;
      }
      ::v-deep .el-tabs__item:hover {
        color: #63ace5;
      }
      ::v-deep .el-tabs__active-bar {
        background-color: #63ace5;
      }
      ::v-deep .el-tabs__nav-wrap::after {
        height: 1px;
      }
      ::v-deep .el-tabs__nav-wrap {
        padding: 0 25px;
        > span {
          font-size: 20px;
          line-height: 39px;
        }
      }
      ::v-deep .content {
        color: #636870;
        padding: 20px 0;
        font-size: 14px;
        line-height: 22px;
      }
      ::v-deep .el-tabs__header {
        margin: 0;
      }
      .page1-load {
        font-size: 14px;
        color: #636870;
        padding: 20px 0;
        display: flex;
        align-items: center;
        img {
          margin-left: 5px;
        }
      }
      .tips {
        color: #969ca4;
        font-size: 12px;
        text-align: right;
        i {
          margin-right: 5px;
        }
      }
    }
    .page2 {
      ul {
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: 20px;
        li {
          display: flex;
          align-items: center;
          cursor: pointer;
          img {
            width: 52px;
            height: 52px;
            margin-right: 15px;
          }
          .page2-right {
            .title {
              color: #4e5969;
              margin-bottom: 5px;
            }
            .num {
              font-size: 20px;
              font-weight: bold;
            }
          }
        }
      }
    }
    .page3,
    .page5 {
      margin-bottom: 20px;
      .page3-main {
        height: 340px;
        width: 100%;
      }
      ::v-deep .is-active {
        color: #63ace5;
        font-size: 20px;
        font-weight: bold;
      }
      ::v-deep .el-tabs__item:hover {
        color: #63ace5;
      }
      ::v-deep .el-tabs__active-bar {
        background-color: #63ace5;
      }
      ::v-deep .el-tabs__item {
        font-size: 16px;
      }
      ::v-deep .el-tabs__nav-wrap::after {
        height: 1px;
      }
      .analysis-class {
        color: #636870;
        font-size: 15px;
        line-height: 25px;
        .analysis-load {
          display: flex;
          align-items: center;
          img {
            margin-left: 5px;
          }
        }
        .analysis-tips {
          text-align: right;
          color: #969ca4;
          font-size: 12px;
          margin-top: 5px;
          i {
            margin-right: 5px;
          }
        }
      }
      .analysis-second {
        h5 {
          font-size: 16px;
          margin-bottom: 10px;
        }
        p {
          margin-bottom: 15px;
          color: #636870;
          font-size: 15px;
          line-height: 25px;
          span {
            color: #333;
            font-weight: bold;
          }
        }
      }
    }
    .page5 {
      .page5-tab {
        display: flex;
        max-width: 100%;
        overflow-x: auto;
        img {
          cursor: pointer;
        }
      }
      ::v-deep .el-tabs__item {
        font-size: 16px;
      }
      ::v-deep .el-tabs__nav-wrap::after {
        height: 1px;
      }
      .page5_min90 {
        min-height: 90px !important;
      }
      .el-tabs {
        margin-top: 20px;
      }
      .page5_first {
        position: relative;
        min-height: 180px;
        .mask {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          img {
            width: 100%;
          }
          .mask_airead {
            position: relative;
            span {
              position: absolute;
              top: 50%;
              left: 50%;
              display: flex;
              grid-gap: 8px;
              gap: 8px;
              align-items: center;
              justify-content: space-between;
              padding: 8px 16px;
              background: #fff;
              border: 1px solid #dcdcdc;
              border-radius: 6px;
              box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.02);
              transform: translate(-50%, -50%);
              cursor: pointer;
              &:hover {
                color: #63ace5;
                border: 1px solid#63ace5;
                small {
                  color: #63ace5;
                }
              }
              img {
                width: 24px;
                height: 24px;
              }
              small {
                height: 22px;
                color: #202224;
                font-weight: 400;
                font-size: 16px;
                line-height: 22px;
              }
            }
          }
        }
      }
    }
  }
  .subject-card {
    background: white;
    border-radius: 5px;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    flex: 1;
    margin-top: 20px;

    .section-title {
      font-size: 1.5rem;
      font-weight: 700;
      color: #1a3c5f;
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      gap: 10px;
      i {
        font-size: 1.7rem;
      }
    }
    .section-zixun {
      .el-button {
        background: #63ace5;
        border-color: #63ace5;
      }
    }
    .new-news {
      margin-top: 30px;
      h3 {
        font-size: 1.2rem;
        margin-bottom: 15px;
        color: #1a3c5f;
        display: flex;
        align-items: center;
        gap: 10px;
      }
      ul {
        li {
          padding: 12px 0;
          border-bottom: 1px solid #eee;
          display: flex;
          align-items: flex-start;
          gap: 10px;
          i {
            border-radius: 50%;
            width: 8px;
            height: 8px;
            background: #63ace5;
            font-size: 0.5rem;
            margin-top: 8px;
            min-width: 8px;
          }
          .news-title {
            cursor: pointer;
            &:hover {
              color: #63ace5;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 1024px) {
  .container-home {
    .concept-left {
      margin-right: 0;
    }

    .concept-left .page2 ul {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
}

@media (max-width: 768px) {
  .container-home {
    width: calc(100% - 24px);

    .concept-left {
      .page1,
      .page2,
      .page3,
      .page4,
      .page5 {
        margin-top: 12px;
        padding: 16px 12px;

        h3 {
          height: auto;
          min-height: 52px;
          margin: -16px -12px 0;
          padding: 0 12px;
          line-height: 52px;
          background-size: min(240px, 75%) 100%;
        }
      }

      .page1 ::v-deep .el-tabs__nav-wrap {
        padding: 0 16px;
      }

      .page2 ul {
        grid-template-columns: 1fr;

        li {
          justify-content: flex-start;
        }
      }

      .page3 .page3-main,
      .page5 .page3-main {
        height: 300px;
      }

      .page5 .page5_first .mask .mask_airead span {
        width: max-content;
        max-width: calc(100% - 24px);
        padding: 6px 10px;
      }
    }
  }
}
</style>
